



























































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";
import MembersMemberDetails from "../members/MembersMemberDetails.vue";

import MemberJson from "../../shared/MemberJson";
import { MemberStatus, MemberStatusNames } from "../../shared/MemberStatus";
import { MembershipType } from "../../shared/MembershipType";
import { MembershipRenewInterval } from "../../shared/MembershipRenewInterval";
import { MembershipTypeNames } from "../../shared/MembershipType";
import { MembershipRenewIntervalNames } from "../../shared/MembershipRenewInterval";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "MembersOverview",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    MembersMemberDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      MemberStatus: MemberStatus,
      MemberStatusNames: MemberStatusNames,
      MembershipType: MembershipType,
      MembershipTypeNames: MembershipTypeNames,
      MembershipRenewIntervalNames: MembershipRenewIntervalNames,
      showDetails: false,
      detailsMode: "read",
      requestedMembers: null as MemberJson[] | null,
      selectedMemberId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: MemberJson | null, mode: string) {
      if (item != null) {
        this.selectedMemberId = item.ID;
      } else {
        this.selectedMemberId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadRequestedMembers();
    },

    async loadRequestedMembers() {
      this.requestedMembers = null;
      this.selectedMemberId = null;

      if (this.restClient != null) {
        try {
          this.requestedMembers = await this.restClient.getMembers([MemberStatus.requested]);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadRequestedMembers();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    memberColumns: function (): TableViewColumnDefinitions<MemberJson>[] {
      let vue = this;

      return [
        {
          th: "Nr.",
          td: (i) => i.ID,
        },
        {
          th: "Name",
          td: (i) =>
            i.customers.length > 0 ? i.customers[0].guardianLastName + ", " + i.customers[0].guardianFirstName : "--",
        },
        {
          th: "Art",
          td: (i) => vue.MembershipTypeNames[i.membershipType],
        },
        {
          th: "Status",
          td: (i) => vue.MemberStatusNames[i.state],
        },
        {
          th: "Automatisch Verlängerung",
          td: (i) => vue.MembershipRenewIntervalNames[i.renewInterval],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<MemberJson>[];
    },
  },
});
